import globals from '../../common/globals';
import Slides from '../vx-campaign-giants/vx-campaign-giants-slides/vx-campaign-giants-slides.vue';

export default {
  name: 'vx-campaign-giants',
  data() {
    return {
      globals,

      currentIndex: 0,
    };
  },
  components: {
    'vx-components-giants-slides': Slides,
  },
  props: {
    slideData: {
      type: Object,
      default: {},
    },
  },
  methods: {
    next() {
      this.currentIndex += 1;
      if (this.slideData && this.currentIndex > this.slideData.slider.length - 1) {
        this.currentIndex = 0;
      }
    },
    prev() {
      this.currentIndex -= 1;
      if (this.slideData && this.currentIndex < 0) {
        this.currentIndex = this.slideData.slider.length - 1;
      }
    },
    icon(ind) {
      this.currentIndex = ind;
    },
    activeClass(ind) {
      return this.currentIndex === ind;
    },
  },
  computed: {
    currentSlider() {
      if (this.slideData) {
        return this.slideData.slider[Math.abs(this.currentIndex) % this.slideData.slider.length];
      }
      return 0;
    },

  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-giants/vx-campaign-giants.js